import styled, { keyframes, css } from "styled-components/macro";
// Add pop-in animation keyframes
const popInAnimation = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

// Add shrink animation keyframes
const shrinkAnimation = keyframes`
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.7);
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    path {
      fill: ${(props) => (props.$faded ? "var(--grey-1)" : "var(--grey-0)")};
    }
  }

  /* Make sure it's visible when tabbed to */
  &:focus-within {
    opacity: 1;
    pointer-events: auto;
    animation: ${popInAnimation} 0.25s ease forwards;
  }

  /* Base styling */
  opacity: ${(props) => (props.shouldBeVisible ? 1 : 0)};
  pointer-events: ${(props) => (props.shouldBeVisible ? "auto" : "none")};

  /* Animation based on visibility */
  ${(props) =>
    props.shouldBeVisible
      ? css`
          animation: ${popInAnimation} 0.25s ease forwards;
        `
      : css`
          animation: ${shrinkAnimation} 0.25s ease forwards;
        `}

  .hover-tip {
    width: auto;
    white-space: nowrap;
    padding: 8px 10px;
    left: calc(50% - ${(props) => props.hoverTipOffsetX}px);
    top: calc(100% + ${(props) => props.hoverTipOffsetY}px);
  }
`;
